export default __webpack_public_path__ + "static/media/calculate_fill.897e45cf.svg";